import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

export default function CustomIconButton({ onClick, src, title, alt }) {
  return (
    <button type="button" className="CustomIconButton" onClick={onClick}>
      <img src={src} alt={alt} title={title} />
    </button>
  );
}

CustomIconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  src: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]).isRequired,
  title: PropTypes.string,
  alt: PropTypes.string,
};

CustomIconButton.defaultProps = {
  alt: '',
  title: '',
};
